import React from 'react';

const InfoLayout = ({ children }) => {
  return <div className="info-layout">{children}</div>;
};

export default InfoLayout;
